import { Language } from '../types/translation-types';
import { LanguageManagementRepository } from '../data/language-management-repository';
import { CreateLanguageRequest } from '../types/language-management-types';

/**
 * Create Language Use Case
 * Creates a new global language
 */
export class CreateLanguageUseCase {
  constructor(private readonly repository: LanguageManagementRepository) {}

  async execute(data: CreateLanguageRequest): Promise<Language> {
    return this.repository.createLanguage(data);
  }
}
